import React from 'react'

import '../Portfolio.css'

const Adventures = () => {
  return (
    <div className='portfolio'>
        Adventures

        <ul>
            <li>
              <a href='/Japan2019'>
              <img src='images/Japan2019/TRI_0266.jpg' alt='Coming Soon' />
                Japan 2019
                </a>
                </li> <br />
            <li>
              <a href='/Europe2020'>
              <img src='images/comingsoon.png' alt='Coming Soon' />
                Europe 2020
                </a>
                </li> <br />
            <li>
              <a href='/WA-OR2021'>
              <img src='images/comingsoon.png' alt='Coming Soon' />
                Washington - Oregon 2021
                </a>
                </li> <br />
            <li>
              <a href='/CA-NV2021'>
<img src='images/comingsoon.png' alt='Coming Soon' />
                California - Nevada 2021
                </a>
                </li> <br />
            <li>
              <a href='/Asia2022'>
              <img src='images/comingsoon.png' alt='Coming Soon' />
                Asia 2022
                </a>
                </li> <br />
        </ul>
    </div>
  )
}

export default Adventures